<template lang="pug">
  header.header.fixed-top
    .container-fluid
      .header__logo
        svg.logo(v-if="lang==='ru'")
          use(xlink:href="#logo--sprite")
        svg.logo(v-if="lang==='en'")
          use(xlink:href="#logoen--sprite")
      nav.header__nav(v-if="lang==='ru'")
        li.header__li(v-for="(name, link) in nav1", :key="link")
          a.header__link.text-uppercase(:href="`#${link}`", v-smooth-scroll="{ offset: -100 }", v-html="name")
      nav.header__nav(v-if="lang==='en'")
        li.header__li(v-for="(name, link) in nav2", :key="link")
          a.header__link.text-uppercase(:href="`#${link}`", v-smooth-scroll="{ offset: -100 }", v-html="name")
      button.button(@click="ruclick") RU
      button.button(@click="enclick") EN
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        nav1:
		{
          service: 'Услуги',
          geography: 'География',
          about: 'О&nbsp;компании',
          // team: 'Команда',
          contacts: 'Контакты'
        },
        nav2:
		{
          service: 'SERVICES',
          geography: 'GEOGRAPHY',
          about: 'ABOUT&nbsp;US',
          // team: 'Команда',
          contacts: 'CONTACTS'
        }
      }
    },
	props: {
	  lang: String
	},
	methods: {
	  ruclick: function()
	  {
        this.lang = 'ru'
		this.$emit('langChanged', this.lang)
	  },
	  enclick: function()
	  {
	    this.lang = 'en'
		this.$emit('langChanged', this.lang)
	  }
	}
  }
</script>

<style lang="scss" scoped>
  @import "../style/variables";
  .header {
    width: 100%;
    display: flex;
    height: 100px;
    text-align: left;
    align-items: center;
    background-color: white;
    box-shadow: $shadow;
    .container-fluid {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__nav {
      display: flex;
      list-style: none;
    }
    &__li {
      &:not(:first-child) {
        margin-left: 40px;
      }
    }
    &__link {
      font-size: 16px;
      color: $color-links;
    }
  }
  .logo {
    width: 307px;
    height: 57px;
  }
  .button {
	color:#cc0000;
	font-size:20px;
	padding:10px;
	background-color:#fff;
	border:1px solid #999;
	border-radius: 20px;
  }
</style>
